export default {
	properties: [
		{
			text: '',
			key: '',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Concepto Movimiento de Stock',
	plural_model_name_spanish: 'Conceptos Movimiento de Stock',
	create_model_name_spanish: 'Nuevo Concepto Movimiento de Stock',
	text_delete: 'el',
}